/*
Stains
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Stains'
const id = '7EwhR8jin3egvIO3GchI'

export default {
  name,
  id,
  filters,
  headers,
  form
}
